import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { ShippingRulePresetApplicationsApiAdapter } from '../adapters/ShippingRulePresetApplicationsApiAdapter';
import { ShippingRulePresetApplicationsFilters } from '../models/ShippingRulePresetApplication';

// Hook que gestiona la obtención y paginación del historial de aplicaciones de presets
export const useShippingRulePresetApplications = (filters: ShippingRulePresetApplicationsFilters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ShippingRulePresetApplicationsApiAdapter(httpClient);

  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const { data, isFetching, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isInitialLoading } =
    useInfiniteQuery({
      queryKey: ['shipping-rule-preset-applications', filters],
      queryFn: ({ pageParam = 1 }) => adapter.getApplicationsPaginated({ ...filters, page: pageParam as number }),
      getNextPageParam: (lastPage) => lastPage.nextPage,
      initialPageParam: 1,
      staleTime: 2 * 60 * 1000,
      gcTime: 5 * 60 * 1000,
      placeholderData: (prev) => prev,
    });

  const applications = data?.pages.flatMap((page) => page.applications) ?? [];
  const total = data?.pages?.[0]?.total ?? 0;

  useEffect(() => {
    if (applications.length > 0 && isFirstLoad) {
      setIsFirstLoad(false);
    }
  }, [applications.length, isFirstLoad]);

  return {
    applications,
    isLoading: isFirstLoad && isInitialLoading,
    isFetching,
    error,
    total,
    refetch,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
  };
};
